export default __webpack_public_path__ + "static/media/intel_logo.d7577f35.jpg";